import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProducts, productThumbnailImageUrl } from "../api/product";

function formatPrice(v) {
  return Number(v || 0).toLocaleString() + "원";
}

export default function ProductListPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    getProducts({ pageSize: 40 })
      .then((res) => setProducts(res.data?.list || []))
      .catch((err) => setError(err.response?.data?.message || "상품을 불러오지 못했습니다."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page product-list-page">
      <h1 className="page-title">상품</h1>
      {loading && <p className="text-sub">불러오는 중...</p>}
      {!loading && error && <p className="error">{error}</p>}
      {!loading && !error && products.length === 0 && <p className="text-sub">판매중인 상품이 없습니다.</p>}

      <div className="product-grid">
        {products.map((p) => (
          <Link to={`/product/${p.productId}`} className="product-card" key={p.productId}>
            <div className="product-thumb">
              <img
                src={productThumbnailImageUrl(p.productId)}
                alt={p.productName}
                onError={(e) => { e.target.style.visibility = "hidden"; }}
              />
            </div>
            <div className="product-name">{p.productName}</div>
            <div className="product-price">
              {p.discountActive ? (
                <>
                  <span className="price-original">{formatPrice(p.basePrice)}</span>
                  <span className="price-final">{formatPrice(p.discountedPrice)}</span>
                </>
              ) : (
                <span className="price-final">{formatPrice(p.basePrice)}</span>
              )}
            </div>
            {(p.totalStock || 0) <= 0 && <span className="status-tag status-CANCELLED">품절</span>}
          </Link>
        ))}
      </div>
    </div>
  );
}
